import { Component, OnInit } from '@angular/core';
import { SectionService } from 'src/app/services/section.service';
import { Office } from 'src/app/entities/office';
import { TransactionService } from 'src/app/services/transaction.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  emailNewsletter = '';
  
  year: number = new Date().getFullYear();

  offices = new Array<Office>();

  constructor(
    protected sectionService: SectionService,
    protected transactionService: TransactionService
    ) { }

  ngOnInit() {
    this.loadOffices();
  }
  
  loadOffices() {
    this.transactionService.offices().toPromise().then(data => {
      if (!data.success) {
        return;
      }
      this.offices = data.response.offices;
    });
  }

  clickNewsletter() {
    this.sectionService.subscribeNewsletter(this.emailNewsletter).toPromise().then(data => {
      if (!data.success) {
        alert(data.error.message);
        return;
      }
      this.emailNewsletter = '';
      alert('Se ha guardado correctamente.');
    });
  }

}
